import { render } from "./bulk-upload.vue?vue&type=template&id=6d7c1388&ts=true"
import script from "./bulk-upload.vue?vue&type=script&lang=ts"
export * from "./bulk-upload.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__